
import { Component, mixins, namespace } from 'nuxt-property-decorator';
import { FormState, FormType, PageDto } from 'fourwaves-shared';
import { TranslateResult } from 'vue-i18n';
import Form from 'fourwaves-shared/src/components/Form.vue';
import FormPageMixin from '~/components/layout/FormPageMixin';
import LegacyHeader from '~/components/layout/LegacyHeader.vue';
import Summary from '~/components/shared/form/Summary.vue';
import ConfirmationPanel from '~/components/shared/form/ConfirmationPanel.vue';
import Breadcrumb from '~/components/shared/form/Breadcrumb.vue';

const EventsModule = namespace('events');

@Component({
  scrollToTop: true,
  components: {
    LegacyHeader,
    Form,
    Summary,
    ConfirmationPanel,
    Breadcrumb,
  },
})
export default class SubmissionMain extends mixins(FormPageMixin) {
  @EventsModule.Getter submissionPage!: PageDto | undefined;

  readonly FormState = FormState;
  type: FormType = FormType.Submission;

  get headerTitle(): string | null {
    if (!this.submissionPage) return null;

    return this.transl8(this.submissionPage.name);
  }

  get headerDescription(): string | null {
    if (this.form.state === FormState.FullWithWaitingList) {
      return `${this.$t('submission.state_FullWithWaitingList')}`;
    }
    if (this.form.state === FormState.PeriodDidNotStart) {
      return `${this.$t('submission.subtitle_not_started')} ${this.showUserFriendlyDate(
        this.currentEvent.submissionStartDate,
      )}`;
    } else if (this.form.state === FormState.PeriodHasEnded) {
      return `${this.$t('submission.subtitle_closed')} ${this.showUserFriendlyDate(
        this.currentEvent.submissionEndDate,
      )}`;
    } else {
      return `${this.$t('submission.subtitle')} ${this.showUserFriendlyDate(this.currentEvent.submissionEndDate)}`;
    }
  }

  get submissionEndedText(): TranslateResult {
    if (this.form.state === FormState.PeriodDidNotStart) {
      return `${this.$t('submission.submission_closed.not_started')} ${this.showUserFriendlyDate(
        this.currentEvent.submissionStartDate,
      )}.`;
    } else if (this.$auth.loggedIn) {
      return this.$t('submission.submission_closed.logged_in_text', { url: this.mySubmissionsUrl });
    } else {
      const url = this.getLoginUrl('', this.mySubmissionsUrl);
      return this.$t('submission.submission_closed.logged_out_text', { url });
    }
  }

  get mySubmissionsUrl(): string {
    return `${this.$config.API_URL}/event-redirect/submissions`;
  }
}
